module.exports = __webpack_public_path__ + "static/0056-60f650fec6b68e1eafd73a255110df4e.png";